import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3311ae94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jr-block jr-pt-18" }
const _hoisted_2 = { class: "jr-flex jr-justify-center jr-items-center jr-mb-51px" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page_name jr-mr-5" }, "人数ボリュームの変化", -1))
const _hoisted_4 = {
  key: 0,
  class: "jr-m-1"
}
const _hoisted_5 = { class: "jr-h-6 jr-leading-6 focus:jr-outline-none jr-bg-gray-light jr-border-gray-light jr-px-3 jr-rounded jr-text-center jr-text-xs jr-text-black-light" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "曜日別：", -1))
const _hoisted_7 = {
  key: 1,
  class: "jr-m-1"
}
const _hoisted_8 = { class: "jr-h-6 jr-leading-6 focus:jr-outline-none jr-bg-gray-light jr-border-gray-light jr-px-3 jr-rounded jr-text-center jr-text-xs jr-text-black-light" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "時間帯：", -1))
const _hoisted_10 = { class: "jr-pb-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-text-center jr-text-sm" }, "市民／市外の比率", -1))
const _hoisted_12 = {
  "data-html2canvas-ignore": "true",
  class: "jr-text-right"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-pl-1.5 jr-text-s jr-text-black-light" }, "(%)", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "jr-text-center jr-text-sm" }, "ボリュームの変化"),
  /*#__PURE__*/_createElementVNode("p", { class: "jr-absolute jr-text-left jr-left-21.5 jr-text-s jr-text-black-light" }, "(%)")
], -1))
const _hoisted_15 = { class: "jr-z-10 jr-h-109px jr-w-63 jr-bg-white jr-rounded" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-text-gray-dark jr-text-s-2 jr-p-4" }, "曜日別／平日・土日祝日", -1))
const _hoisted_17 = { class: "jr-w-full jr-flex jr-justify-end jr-pt-4.252" }
const _hoisted_18 = { class: "jr-flex jr-justify-between jr-pb-1.25" }
const _hoisted_19 = {
  key: 0,
  class: "jr-text-s-2 jr-text-gray-dark"
}
const _hoisted_20 = {
  key: 1,
  class: "jr-text-s-2 jr-text-gray-dark"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "jr-pt-7.5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIBarChart = _resolveComponent("UIBarChart")!
  const _component_ContentWrapper = _resolveComponent("ContentWrapper")!
  const _component_UISelection = _resolveComponent("UISelection")!
  const _component_UICheckboxFilter = _resolveComponent("UICheckboxFilter")!
  const _component_UITimeSlider = _resolveComponent("UITimeSlider")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_FilterWrapper = _resolveComponent("FilterWrapper")!
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ContentWrapper, {
      class: "jr-overflow-auto",
      filters: [],
      startDate: _ctx.startDate,
      endDate: _ctx.endDate,
      "show-download": true,
      dayLabel: _ctx.$store.getters['chart/getDayLabel'],
      weekLabel: _ctx.$store.getters['chart/getWeekLabel'],
      timeLabel: _ctx.$store.getters['chart/getTimeRangeLabel'],
      "is-max-width": false,
      onResetTime: _ctx.resetTime,
      onResetDay: _ctx.resetDay,
      onResetWeek: _ctx.resetWeek
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          id: "content-download-road-graph",
          class: _normalizeClass(["content jr-pb-77px", {'jr-px-79px': !_ctx.isCapturing, 'jr-px-9': _ctx.isCapturing}])
        }, [
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              (_ctx.dayLabel.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("span", null, _toDisplayString(_ctx.dayLabel), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.timeLabel.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("span", null, _toDisplayString(_ctx.timeLabel), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 512), [
            [_vShow, _ctx.isCapturing]
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "btn_download jr-py-1 jr-w-20 jr-h-7.5 jr-rounded jr-text-center jr-text-s-2 jr-content-end jr-bg-white jr-text jr-border-blue-bold jr-text-blue-bold jr-border-1",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setDatalabels && _ctx.setDatalabels(...args)))
              }, " 数値表示 ")
            ]),
            _hoisted_13
          ]),
          _createVNode(_component_UIBarChart, {
            datasets: _ctx.normalChart,
            stackBar: true,
            title: _ctx.title,
            dataLabel: _ctx.dataLabel,
            selectionValue: _ctx.$store.state.chart.selectedFilterType,
            maxValue: _ctx.maxValue,
            maxDataSetlength: _ctx.maxDataSetlength,
            class: "jr-mb-49px"
          }, null, 8, ["datasets", "title", "dataLabel", "selectionValue", "maxValue", "maxDataSetlength"]),
          _hoisted_14,
          _createVNode(_component_UIBarChart, {
            datasets: _ctx.volumnChart,
            stackBar: false,
            dataLabel: _ctx.dataLabel,
            maxValue: _ctx.maxValue,
            max: _ctx.maxVolumne,
            selectionValue: _ctx.$store.state.chart.selectedFilterType,
            maxDataSetlength: _ctx.maxDataSetlength
          }, null, 8, ["datasets", "dataLabel", "maxValue", "max", "selectionValue", "maxDataSetlength"])
        ], 2)
      ]),
      _: 1
    }, 8, ["startDate", "endDate", "dayLabel", "weekLabel", "timeLabel", "onResetTime", "onResetDay", "onResetWeek"]),
    _withDirectives(_createVNode(_component_FilterWrapper, null, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["jr-w-full jr-pt-5 jr-pl-5 jr-pr-5", {'right_column': !_ctx.isCapturing, 'jr-opacity-0': _ctx.isCapturing}])
        }, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_UISelection, {
              class: "jr-mx-5",
              options: _ctx.selectionOptions,
              modelValue: _ctx.$store.state.chart.selectedFilterType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$store.state.chart.selectedFilterType) = $event))
            }, null, 8, ["options", "modelValue"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["jr-absolute jr-left-10 jr-border-l-2 jr-border-b-2 jr-border-blue-light-soft jr-w-5", {
            'jr-h-39.5': _ctx.$store.getters['chart/filterDay'],
            'jr-h-30.752': _ctx.$store.getters['chart/filterWeek']
          }])
          }, null, 2),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", {
              class: _normalizeClass(["jr-bg-white jr-w-53 jr-p-5 jr-pt-3 jr-rounded", {
              'jr-pb-6.252': _ctx.$store.getters['chart/filterDay'],
              'jr-pb-3.9': _ctx.$store.getters['chart/filterWeek']
            }])
            }, [
              _createElementVNode("div", _hoisted_18, [
                (_ctx.$store.getters['chart/filterDay'])
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, "曜日別"))
                  : _createCommentVNode("", true),
                (_ctx.$store.getters['chart/filterWeek'])
                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, "平日・土日祝日"))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "jr-text-xxs-1 jr-text-blue-bold",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleClearFilter && _ctx.handleClearFilter(...args)))
                }, "クリア")
              ]),
              (_ctx.$store.getters['chart/filterDay'])
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(_component_UICheckboxFilter, {
                      modelValues: _ctx.$store.state.chart.dayFilter,
                      "onUpdate:modelValues": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.$store.state.chart.dayFilter) = $event)),
                      options: _ctx.availableDayFilter,
                      type: "day"
                    }, null, 8, ["modelValues", "options"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$store.getters['chart/filterWeek'])
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createVNode(_component_UICheckboxFilter, {
                      modelValues: _ctx.$store.state.chart.weekFilter,
                      "onUpdate:modelValues": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.$store.state.chart.weekFilter) = $event)),
                      options: _ctx.availableWeekFilter,
                      type: "week"
                    }, null, 8, ["modelValues", "options"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("hr", {
                class: _normalizeClass(["jr-border-t-1 jr-border-dashed jr-border-blue-light-soft", {
                'jr-mt-4.5': _ctx.$store.getters['chart/filterDay'],
                'jr-mt-6': _ctx.$store.getters['chart/filterWeek']
              }])
              }, null, 2),
              _createElementVNode("div", null, [
                _createVNode(_component_UITimeSlider, {
                  time: _ctx.$store.state.chart.time,
                  "onUpdate:time": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.$store.state.chart.time) = $event)),
                  min: 0,
                  max: 24
                }, null, 8, ["time"])
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_UIButton, {
              class: "jr-w-full jr-text-center jr-h-10 jr-leading-9 jr-text-sm jr-rounded",
              label: '適用',
              type: 'primary',
              onClick: _ctx.handleSearch
            }, null, 8, ["onClick"])
          ])
        ], 2)
      ]),
      _: 1
    }, 512), [
      [_vShow, !_ctx.isCapturing]
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}